import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=18f06916&scoped=true"
import script from "./documentList.vue?vue&type=script&lang=js"
export * from "./documentList.vue?vue&type=script&lang=js"
import style0 from "./documentList.vue?vue&type=style&index=0&id=18f06916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f06916",
  null
  
)

export default component.exports